<template>
	<div class="item">
		<div class="item-title">
			{{ project.name }}
			<div class="title-detail">{{ projectLine.amount }} {{ projectLine.unit }}</div>
		</div>
		<div v-if="index === 0 && projectLine.product_id === 77" class="input-details">
			<div class="input-container">
				<DateField id="date-input-impregneren" :disabled="isDisabled" placeholder="01-01-2022" v-model="formData.impregneren.impregneren_date"></DateField>
				<span class="error-message" v-if="this.errors.includes('impregneren_date')">Mag niet leeg zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="start-time-input-impregneren" id="start-time-input-impregneren" :disabled="isDisabled" placeholder="09:00" v-model="formData.impregneren.impregneren_start_time">
				<span class="error-message" v-if="this.errors.includes('impregneren_start_time')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="end-time-input-impregneren" id="end-time-input-impregneren" :disabled="isDisabled" placeholder="15:00" v-model="formData.impregneren.impregneren_end_time">
				<span class="error-message" v-if="this.errors.includes('impregneren_end_time')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<select class="input-item" name="user-input-impregneren" id="user-input-impregneren" :disabled="isDisabled" v-model="formData.impregneren.impregneren_user">
					<option :value="null" disabled selected>Selecteer een bus</option>
					<option v-for="van in vans" :value="van.id">{{ van.display_name }}</option>
				</select>
				<span class="error-message" v-if="this.errors.includes('impregneren_user')">Selecteer een bus</span>
			</div>
		</div>
	</div>
</template>

<script>
import {validateNotEmptyOrEmptyString, validateNotNull, validateTime} from "../common/validators";
import DateField from "./DateField";

export default {
	name: "ExecutionAppointmentAdditionalProject",
	components: {DateField},
	props: {
		project: Object,
		index: Number,
		vans: Array,
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			product: '',
			projectLine: Object,
			formData: {
				impregneren: {
					impregneren_date: "",
					impregneren_start_time: "",
					impregneren_end_time: "",
					impregneren_user: null
				}
			},
			formValidators: {
				impregneren: {
					impregneren_date: validateNotEmptyOrEmptyString,
					impregneren_start_time: validateTime,
					impregneren_end_time: validateTime,
					impregneren_user: validateNotNull
				}
			},

			errors: []
		};
	},

	computed: {},

	methods: {
		validateFields() {
			const formDataObject = this.formData[this.product];
			const formValidatorObject = this.formValidators[this.product];

			const hasData = Object.values(formDataObject).some(
				(formValue) => (formValue == null || (typeof formValue === "string" && formValue.trim() === "")) === false
			);

			if (formValidatorObject == null || (this.product === 'impregneren' && hasData === false)) {
				// No validation available so it's optional
				return;
			}

			for (const [field, validationFunction] of Object.entries(formValidatorObject)) {
				const value = formDataObject[field];
				validationFunction(value) !== true ? this.errors.push(field) : this.removeFormErrors(field);
			}
		},

		removeFormErrors(value) {
			this.errors = this.errors.filter(error => error !== value);
		},

		getFormValues() {
			if (this.product === 'impregneren') {
				this.formData[this.product].impregneren_project_id = this.project.id;
			}

			return this.formData[this.product];
		}
	},

	beforeMount() {
		this.projectLine = this.project.projectLines[0];

		if (this.projectLine.product_id === 77) {
			this.product = 'impregneren';
		}
	}
}
</script>

<style scoped lang="scss">
.input-details {
	display: flex;
	flex-direction: row;
	padding-top: 1em;
	justify-content: space-between;

	.error-message {
		color: red;
	}

	.input-container {
		width: 20%;
		display: flex;
		flex-direction: column;

		> input, > select, ::v-deep > .DateField .DateField__group .TextField {
			border: 2px solid #ced6dd;
			border-radius: 5px;
			box-shadow: none;
			margin: 0 0 8px 0;
			padding: 0.5em;
			background: #FFF;
			font-size: 1rem;
		}

		::v-deep > .DateField .DateField__group .DateField__toggle {
			top: 0;
		}
	}

	.input-container.add-row-button {
		width: 3%;
		font-size: 1.8rem;
		min-width: 36px;
		height: 34px;
		border: none;
		background: #FFF;
	}
}
</style>
